class SizeGuideDrawer extends HTMLElement {
  connectedCallback() {
    this.overlay = this.querySelector('.size-guide-drawer__overlay');
    this.closeBtn = this.querySelector('.size-guide-drawer__close');
    this.unitBtns = this.querySelectorAll('.size-guide-drawer__unit-btn');
    this.cells = this.querySelectorAll('.size-guide-drawer__table-cell[data-cm]');

    this.overlay?.addEventListener('click', () => this.close());
    this.closeBtn?.addEventListener('click', () => this.close());
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.classList.contains('active')) this.close();
    });

    // Unit switch
    this.unitBtns.forEach(btn => {
      btn.addEventListener('click', () => this.setUnit(btn.dataset.unit));
    });

    // Default to inches (for USA market)
    this.setUnit('in');
  }

  open() {
    this.classList.add('active');
    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    document.body.classList.remove('overflow-hidden');
  }

  setUnit(unit) {
    // Update buttons
    this.unitBtns.forEach(btn => {
      btn.classList.toggle('active', btn.dataset.unit === unit);
    });

    // Convert values
    this.cells.forEach(cell => {
      const cmValue = cell.dataset.cm;
      cell.textContent = this.convertValue(cmValue, unit);
    });
  }

  convertValue(cmString, unit) {
    // Parse CM value (handles ranges like "85-94 CM" or single values like "116 CM")
    const cleaned = cmString.replace(/\s*CM\s*/gi, '').trim();
    
    if (cleaned.includes('-')) {
      // Range value (e.g., "85-94")
      const [min, max] = cleaned.split('-').map(v => parseFloat(v.trim()));
      if (isNaN(min) || isNaN(max)) return cmString;
      
      if (unit === 'in') {
        const minIn = (min / 2.54).toFixed(1);
        const maxIn = (max / 2.54).toFixed(1);
        return `${minIn}-${maxIn}"`;
      } else {
        return `${min}-${max} CM`;
      }
    } else {
      // Single value (e.g., "116")
      const value = parseFloat(cleaned);
      if (isNaN(value)) return cmString;
      
      if (unit === 'in') {
        return `${(value / 2.54).toFixed(1)}"`;
      } else {
        return `${value} CM`;
      }
    }
  }
}

customElements.define('size-guide-drawer', SizeGuideDrawer);

// Init buttons
document.addEventListener('DOMContentLoaded', () => {
  // Standalone button
  document.querySelectorAll('.size-guide-button').forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      document.getElementById(`SizeGuideDrawer-${btn.dataset.sizeGuideHandle}`)?.open();
    });
  });
  
  // Button inside variant picker
  document.querySelectorAll('.form__label-size-guide').forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      document.getElementById(`SizeGuideDrawer-${btn.dataset.sizeGuideHandle}`)?.open();
    });
  });
});

